module.exports = __webpack_public_path__ + "media/images/soar/advantages_person-ae2f8f9ff0ed49dbb629163bb4f25b37.png";